import React, { useEffect, useState, useRef } from "react";
import api from "../../../api";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const SemesterWiseReports = ({ uid }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [mergedCourses, setMergedCourses] = useState([]);
  const tableRefs = useRef([]);

  const addToRefs = (el) => {
    if (el && !tableRefs.current.includes(el)) {
      tableRefs.current.push(el);
    }
  };
  // Fetch academic years on component mount
  useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/users/getacademicyear/${uid}`);
        setData(res.data);
      } catch (err) {
        console.error("Error fetching academic years:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAcademicYears();
  }, [uid]);

  // Fetch course data whenever selectedYear changes
  useEffect(() => {
    if (!selectedYear) return;

    const fetchCoursesAndMergeData = async () => {
      try {
        setLoading(true);

        // Fetch courses for the selected year
        const coursesRes = await api.get(
          `/api/reports/getsemesterwiseuid/${uid}`,
          {
            params: { selectedYear },
          }
        );
        const courses = coursesRes.data;

        // Prepare arrays for merging results and averages
        const mergedData = [];

        // Fetch results and averages for each course
        for (let course of courses) {
          try {
            const [resultsRes, averagesRes] = await Promise.all([
              api.get(`api/reports/getcourseresult/${course.usercourse_id}`),
              api.get(`/api/reports/getaverages/${course.usercourse_id}`),
            ]);

            mergedData.push({
              ...course,
              results: resultsRes.data || [],
              averages: averagesRes.data || [],
            });
          } catch (err) {
            console.error(
              `Error fetching data for course ${course.usercourse_id}:`,
              err
            );
          }
        }

        setMergedCourses(mergedData);
      } catch (err) {
        console.error("Error fetching course data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCoursesAndMergeData();
  }, [selectedYear, uid]);

  // const generatePDF = () => {
  //   const headerNav = document.getElementById("header_nav");
  //   if (headerNav) headerNav.style.display = "none";

  //   const downloadButton = document.getElementById("downloadButton");
  //   const inputFieldsRemove = document.getElementById("inputFieldsRemove");
  //   if (downloadButton) downloadButton.style.display = "none";
  //   if (inputFieldsRemove) inputFieldsRemove.style.display = "none";

  //   const img_h = document.getElementById("banner_for_output");
  //   if (img_h) {
  //     img_h.style.display = "block";
  //     img_h.style.width = "100%";
  //   }

  //   const resetStyles = () => {
  //     if (headerNav) headerNav.style.display = "";
  //     if (downloadButton) downloadButton.style.display = "";
  //     if (inputFieldsRemove) inputFieldsRemove.style.display = "";
  //     if (img_h) {
  //       img_h.style.display = "none";
  //       img_h.style.width = "";
  //     }

  //     window.onafterprint = null;
  //   };

  //   window.onafterprint = resetStyles;
  //   window.print();
  // };

  const generatePDF = async () => {
    setLoading(true);
    const pdf = new jsPDF();
  
    const collegeHeader = "/images/CollegeHeader.png";
    let yPosition = 20; // Initial Y position after the header
  
    // Flag to check if it's the first table
    let isFirstTable = true;
    let currentSemester = null; // Track the current semester
  
    for (const table of tableRefs.current) {
      if (table) {
        // Add header image
        const headerImage = new Image();
        headerImage.src = collegeHeader;
  
        // Wait for the header image to load
        await new Promise((resolve) => {
          headerImage.onload = resolve;
        });
  
        const semester = table.getAttribute("data-semester"); // Assuming you set `data-semester` for each table div
  
        // Check if the semester has changed
        if (semester !== currentSemester) {
          if (!isFirstTable) {
            pdf.addPage(); // Add a new page for a new semester
          }
  
          // Add header to the new page
          pdf.addImage(headerImage, "PNG", 10, 10, 190, 20);
          yPosition = 40; // Reset Y position
          currentSemester = semester; // Update current semester
        }
  
        isFirstTable = false; // Ensure only the first header gets the extra margin
  
        // Capture table as an image
        const canvas = await html2canvas(table);
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 190; // A4 width in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
        // Check if the table fits on the current page
        const remainingPageHeight = 280 - yPosition; // Remaining space on the page (280 is A4 height minus margins)
        if (imgHeight > remainingPageHeight) {
          pdf.addPage(); // Add a new page if the table doesn't fit
          yPosition = 40; // Reset Y position for the new page
  
          // Add the header to the new page
          pdf.addImage(headerImage, "PNG", 10, 10, 190, 20);
        }
  
        // Add the table image to the PDF
        pdf.addImage(imgData, "PNG", 10, yPosition, imgWidth, imgHeight);
        yPosition += imgHeight + 20; // Update yPosition for the next table
      }
    }
  
    // Save the PDF
    pdf.save("tables.pdf");
    setLoading(false);
  };
  
 console.log(mergedCourses);
  // Render semester-wise courses
  return (
    <div className="w-full">
      <img
        id="banner_for_output"
        style={{ display: "none" }}
        src="/images/CollegeHeader.png"
        alt=""
      />

      <div className="w-full mt-8">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Semester Wise Reports
        </h1>

        {loading ? (
          <p className="text-blue-500 text-center">Loading data...</p>
        ) : (
          <div className="w-full max-w-md mx-auto mb-8" id="inputFieldsRemove">
            <label
              htmlFor="academicYear"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Select Academic Year:
            </label>
            <select
              id="academicYear"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="block w-full p-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>
                -- Select Academic Year --
              </option>
              {data.map((item, index) => (
                <option key={index} value={item.academic_year}>
                  {item.academic_year}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="overflow-x-auto">
          {mergedCourses.length > 0 &&
            mergedCourses.map((course, index) => (
              <div key={index} className="mb-6"  ref={addToRefs} data-semester={course.semester}>
                {index === 0 ||
                course.semester !== mergedCourses[index - 1]?.semester ? (
                  <h2 className="text-4xl font-bold mb-6 py-3 px-4 mt-6 text-purple-700 bg-white rounded-md">
                    Semester {course.semester}
                  </h2>
                ) : null}

                <h3 className="text-lg font-semibold mb-2">
                  {course.coursecode} - {course.course_name} : {course.teacher_name}
                </h3>
                <table className="w-full text-sm text-left border border-gray-200 rounded-lg mb-6">
                  <thead className="bg-purple-800 text-white">
                    <tr>
                      <th className="py-2 px-4 text-center" colSpan="15">
                        Teacher: {course.teacher_name || "N/A"}
                      </th>
                    </tr>
                    <tr>
                      <th className="py-2 px-4">CO Name</th>
                      <th className="py-2 px-4">PO 1</th>
                      <th className="py-2 px-4">PO 2</th>
                      <th className="py-2 px-4">PO 3</th>
                      <th className="py-2 px-4">PO 4</th>
                      <th className="py-2 px-4">PO 5</th>
                      <th className="py-2 px-4">PO 6</th>
                      <th className="py-2 px-4">PO 7</th>
                      <th className="py-2 px-4">PO 8</th>
                      <th className="py-2 px-4">PO 9</th>
                      <th className="py-2 px-4">PO 10</th>
                      <th className="py-2 px-4">PO 11</th>
                      <th className="py-2 px-4">PO 12</th>
                      <th className="py-2 px-4">PSO 1</th>
                      <th className="py-2 px-4">PSO 2</th>
                      {/* Add remaining columns here */}
                    </tr>
                  </thead>
                  <tbody>
                    {course.results.map((result, index) => (
                      <tr
                        key={index}
                        className={
                          index % 2 === 0 ? "bg-purple-50" : "bg-white"
                        }
                      >
                        <td className="py-2 px-4">{result.co_name}</td>
                        <td className="py-2 px-4">{result.po_1 || "-"}</td>
                        <td className="py-2 px-4">{result.po_2 || "-"}</td>
                        <td className="py-2 px-4">{result.po_3 || "-"}</td>
                        <td className="py-2 px-4">{result.po_4 || "-"}</td>
                        <td className="py-2 px-4">{result.po_5 || "-"}</td>
                        <td className="py-2 px-4">{result.po_6 || "-"}</td>
                        <td className="py-2 px-4">{result.po_7 || "-"}</td>
                        <td className="py-2 px-4">{result.po_8 || "-"}</td>
                        <td className="py-2 px-4">{result.po_9 || "-"}</td>
                        <td className="py-2 px-4">{result.po_10 || "-"}</td>
                        <td className="py-2 px-4">{result.po_11 || "-"}</td>
                        <td className="py-2 px-4">{result.po_12 || "-"}</td>
                        <td className="py-2 px-4">{result.pso_1 || "-"}</td>
                        <td className="py-2 px-4">{result.pso_2 || "-"}</td>
                      </tr>
                    ))}

                    {course.averages.map((avg, avgIndex) => (
                      <tr
                        key={`avg-${avgIndex}`}
                        className="bg-purple-100 font-semibold text-gray-700"
                      >
                        <td className="py-2 px-4">
                          {avg.isset === 0
                            ? "Set"
                            : avg.isset === 1
                            ? "Target"
                            : "-"}
                        </td>
                        <td className="py-2 px-4">{avg.po_1 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_2 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_3 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_4 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_5 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_6 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_7 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_8 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_9 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_10 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_11 || "-"}</td>
                        <td className="py-2 px-4">{avg.po_12 || "-"}</td>
                        <td className="py-2 px-4">{avg.pso_1 || "-"}</td>
                        <td className="py-2 px-4">{avg.pso_2 || "-"}</td>
                        {/* Add remaining cells here */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
        </div>

        <button
          id="downloadButton"
          onClick={generatePDF}
          className="bg-purple-600 mt-4 text-white px-4 py-2 rounded hover:bg-purple-700"
        >
          {loading ? "Printing..." : "Download PDF"}
        </button>
      </div>
    </div>
  );
};

export default SemesterWiseReports;
